import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp, throwIfResultHasErrors } from 'src/lib/graphql';

import { USER_INVITE_FRAGMENT } from './schema';

const QUERY = gql`
  query InviteDetails($token: String!) {
    inviteDetails(token: $token) {
      ...UserInvite
    }
  }
  ${USER_INVITE_FRAGMENT}
`;

export const queryInviteDetails = async (token) => {
  const params = {
    query: QUERY,
    variables: { token },
  };

  const result = await executeGqlQuery(params);
  throwIfResultHasErrors(result);

  return getSingleProp(result.data);
};
